"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DownloadLinkBox = _interopRequireDefault(require("../../../SIA-WEBSITE/DownloadLinkBox/DownloadLinkBox"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-masterpreis-homepage .links-grid {\n  padding-left: 16px;\n  padding-right: 16px;\n  display: flex;\n  justify-self: start;\n  padding-left: 32px;\n  gap: 64px; }\n  .sia-masterpreis-homepage .links-grid .downloadlinkbox {\n    width: fit-content; }\n  .sia-masterpreis-homepage .links-grid .downloadlinkbox-container {\n    padding-right: 0px;\n    width: max-content;\n    max-width: 100%; }\n    .sia-masterpreis-homepage .links-grid .downloadlinkbox-container p {\n      width: fit-content;\n      max-width: 100%; }\n\n@media (max-width: 66rem) {\n  .sia-masterpreis-homepage .links-grid .downloadlinkbox-container {\n    width: fit-content; } }\n\n@media (max-width: 42rem) {\n  .sia-masterpreis-homepage .links-grid {\n    flex-direction: column;\n    gap: 0px;\n    justify-self: start;\n    padding-left: 8px; }\n    .sia-masterpreis-homepage .links-grid .downloadlinkbox-container {\n      width: fit-content; } }\n";
  const fileName = "LinksGrid_LinksGrid";
  const element = document.querySelector("style[data-sass-component='LinksGrid_LinksGrid']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const LinksGrid = _ref => {
  let {
    links,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "links-grid"
  }, links.map(link => /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    key: link.id,
    items: [link],
    lang: lang
  })));
};
var _default = exports.default = LinksGrid;